import React, { useRef, useState, useEffect } from "react";
import { Spin, Select, Input, message, Modal, Button, Form } from "antd";
import { SearchOutlined, LoginOutlined } from "@ant-design/icons";
import styled from "styled-components";
import DoubleleftSvg from '@/img/doubleleft.png';
import RefreshImg from '@/img/refresh.png';
import { useSelector } from "react-redux";
import OpenData from '@/components/open-data/open-data';
import api from "@/apis/pc/user/user";
import apiConversation from "@/apis/pc/conversation/conversation";
import { getParameterByName, timerFn } from "@/utils/utils";
import _ from 'lodash';

const Wrapper = styled.div`
  width: ${(props) => props.active ? '304px' : '88px'};
  border-right: 1px solid #E8EBF6;
  overflow-y: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-box{
    padding: 24px;
    padding-bottom: 10px;
    width: 100%;
    .ant-input-affix-wrapper{
      border-radius: 4px;
      border: 1px solid #E8EBF6;
    }
    .ant-input-affix-wrapper-focused{
      border: 1px solid var(--ant-primary-color);
    }
    .ant-input&::placeholder {
      color: #9A9EBA;
    }
    .ant-input-suffix{
      color: #9A9EBA;
    }
  }
  .search-box-hidden{
    padding: 32px 36px 27px;
    cursor: pointer;
  }
  .tab-box{
    display: flex;
    color: #767B9E;
    margin: 0 24px;
    justify-content: space-between;
    border-bottom: 1px solid #E8EBF6;
    align-items: center;
    position: relative;
    .tab-item{
      flex: none;
      cursor: pointer;
      padding-bottom: 14px;
      padding-top: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #767B9E;
      line-height: 20px;
    }
    .tab-item-active{
      color: var(--ant-primary-color);
      position: relative;
      &::after{
        content: '';
        width: 100%;
        height: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: var(--ant-primary-color);
      }
    }
    .tab-item-refresh{
      color: var(--ant-primary-color);
      cursor: pointer;
      font-size: 16px;
      width: 16px;
      height: 16px;
      img{
        width: 100%;
        height: 100%
      }
    }
    .ant-input-affix-wrapper{
      border-color: #E8EBF6;
      border-radius: 4px;
    }
    .action-box{
      padding: 8px 2px 8px 1px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #E8EBF6;
      border-right-width: 0;
      position: absolute;
      right: -24px;
      top: 9px;
      height: 30px;
      flex: none;
      cursor: pointer;
      display: flex;
      img{
        width: 14px;
        height: 14px;
      }
    }
  }
  .tab-box-hidden{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    .tab-item-refresh{
      color: var(--ant-primary-color);
      cursor: pointer;
      font-size: 16px;
      width: 16px;
      height: 16px;
      img{
        width: 100%;
        height: 100%
      }
    }
    .action-box{
      padding: 8px 2px 8px 1px;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #E8EBF6;
      border-left-width: 0;
      position: absolute;
      right: 0px;
      top: 0px;
      height: 30px;
      flex: none;
      cursor: pointer;
      display: flex;
      transform: rotate(180deg);
      img{
        width: 14px;
        height: 14px;
      }
    }
  }
  .user-box-hidden{
    overflow-y: auto;
    margin-top: 8px;
    .user-item-active{
      background: rgba(252,131,82,0.1);
    }
    .user-item{
      margin-top: 8px;
      padding: 8px 0px;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover{
        background: rgba(252,131,82,0.1);
      }
      .user-icon{
        width: 40px;
        height: 40px;
        border-radius: 4px;
        flex: none;
      }
      .user-message{
        width: 32px;
        height: 18px;
        line-height: 18px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E8EBF6;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #130928;
        flex: none;
        right: 8px;
        top: -2px;
        position: absolute;
      }
    }
  }
  .user-box{
    overflow-y: auto;
    .user-item-active{
      background: rgba(252,131,82,0.1);
    }
    .user-item{
      display: flex;
      align-items: center;
      padding: 8px 24px;
      margin-top: 8px;
      cursor: pointer;
      &:hover{
        background: rgba(252,131,82,0.1);
      }
      .user-icon{
        width: 40px;
        height: 40px;
        border-radius: 4px;
        flex: none;
        margin-right: 8px;
      }
      .user-content{
        flex: 1;
        overflow: hidden;
        .user-content-top{
          line-height: 20px;
          display: flex;
          align-items: center;
          .user-name{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #130928;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .user-label{
            margin-left: 4px;
            padding 0 4px;
            border-radius: 4px;
            background: #E5F1FE;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #52A5FC;
            flex: none;
          }
          .user-leave{
            background: #EBECF1;
            color: #9A9EBA;
          }
            .user-inheritance{
            background: #FDE3E7;
            color: #d04e0dff;
          }
        }
        .user-dep{
          margin-top: 2px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #9A9EBA;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .user-message{
        width: 32px;
        height: 18px;
        line-height: 18px;
        background: #FFFFFF;
        border-radius: 10px;
        border: 1px solid #E8EBF6;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #130928;
        flex: none;
        margin-left: 2px;
      }
    }
  }
`;

const CovSearchUserList = (props) => {
  const [showAll, setShowAll] = useState(true); // 是否展示全部
  const [searchInput, setSearchInput] = useState(''); // 搜索关键词
  const [loading, setLoading] = useState(false); // 是否加载
  const currentUser = useSelector((state) => state.userInfo.userInfo); // 当前登录用户信息
  const [list, setList] = useState([]); // 当前查看的用户数据
  const [currentData, setCurrentData] = useState(null); // 当前查看的用户
  const [status, setStatus] = useState(''); // tan状态
  const userStautsList = [{value: '全部存档员工', key: ''},{value: '在职员工', key: '1'},{value: '离职员工', key: '0'}]
  const condition = useRef({ appSource: 2, status: '' }); // 搜索条件
  const isInit = useRef(true);

  const fetchListTimer = useRef(null); // 获取人员数据的定时器

  // 切换分类
  const changeTab = (key) => {
    setStatus(key);
  }

  const getData = async (isInit) => {
    setLoading(true)
    let params = condition.current;
    params.appSource = 2;
    api.getCovUsers([], params).then(res => {
      let data = res.data || [];
      let arr = [];
      data?.forEach(item => {
        // 已离职
        const commonInfo = {
          id: item.uid,
          name: item.name,
          company: item.corpName,
          avatarUrl: item.avatarUrl,
          openWxUserid: item.openWxUserid,
          userTab: params.status,
        }
        // 不再需要分类
        arr.push({...item, ...commonInfo});
      })
      setList(arr);
      console.log(arr, 'temptemptemp')
      // if (isInit) {
        setCurrentData(arr[0] || null);
      // }
      // condition.current.hasNextPage = data?.length === condition.current.pageSize;
    }).finally(() => {
      setLoading(false)
    })
  };

  // crm客户详情下员工列表
  const getCurrentUserEnableByIframe = (crmContactId, data, crmCustomerId, whiteList) => {
    const crmContactIds = crmContactId.split(',')?.filter(item => item)?.map(item => Number(item))
    // reallyOid iframe下 只有top下有current_org
    const reallyOid = process.env.NODE_ENV === 'development' ? process.env?.OID : window?.top?.current_org?.oid
    const params = { oid: reallyOid, contactIds: crmContactIds,  }
    if (whiteList) {
      // 灰度名单中的新crm 好友
      params.crmCustomerId = crmCustomerId
    } else {
      const crmContactIds = crmContactId.split(',')?.filter(item => item)?.map(item => Number(item))
      if(crmContactIds?.length < 1) {
        return
      } else {
        params.contactIds = crmContactIds
      }
    }

    api.getCovUsersByIframe(params).then(response => {
      if (response.code === 0) {
        if (response.data.length > 0) {
          setCurrentData(response.data[0]);
          setList(response.data);
        }
      } else {
        message.warning(
          response.message
        );
      }
    }).catch(err => {
      message.error(err?.message)
    })
  }

  useEffect(() => {
    const isIframe = getParameterByName("deviceType") === "iframe" ? true : false;
    if (isInit.current) {
      if(isIframe){
        // iframe是客户详情下的企微聊天记录tab 这里的员工列表使用另外一个接口
        const crmContactId = getParameterByName("contactsIds", true);
        const crmCustomerId = getParameterByName("id");
        const scrmFriend = getParameterByName("scrm_friend", true); // 是否是新版的crm好友
        getCurrentUserEnableByIframe(crmContactId, null, crmCustomerId, scrmFriend)
      } else {
        getData(true);
      }
    } else {
      getData();
    }
  }, [])

  useEffect(() => {
    if (_.get(currentData, 'id', '')) {
      props.onChange && props.onChange(currentData);
    } else {
      props.onChange && props.onChange({});
    }
  }, [currentData])

  useEffect(() => {
    condition.current.status = status;
    refresh(true);
  }, [status, fetchListTimer])

  // 刷新数据
  const refresh = (noSearch) => {
    setLoading(true)
    timerFn(fetchListTimer.current, () => {
      getData();
      !noSearch && props.onSearchMessage && props.onSearchMessage();
    });
  }
  return (
    <Wrapper active={showAll}>
      <Spin spinning={loading}>
      {
        showAll ? (
          <>
            <div className="search-box">
              <Input
                placeholder="请输入搜索内容"
                value={searchInput}
                onInput={(e) => {
                  setSearchInput(e.target.value);
                }}
                suffix={
                  <SearchOutlined
                      style={{
                        color: '#9A9EBA',
                      }}
                    />
                }
              />
            </div>
            <div className="tab-box">
              {
                userStautsList.map(item => {
                  return (
                    <div
                      className={['tab-item', status === item.key ? 'tab-item-active' : ''].join(' ')}
                      onClick={() => changeTab(item.key)}
                      key={item.key}
                    >{item.value}</div>
                  );
                })
              }
              <img src={RefreshImg} className="tab-item-refresh" onClick={() => {refresh()}}/>
              <div className="action-box" onClick={() => setShowAll(!showAll)}>
                <img src={DoubleleftSvg} />
              </div>
            </div>
      
            <div className="user-box scroll-style">
              {
                list.map(item => {
                  if (!_.isEmpty(searchInput)) {
                    const searchName = searchInput.trim();
                    if (!_.isEmpty(searchName)) {
                      if (_.get(item , 'name', '').indexOf(searchName) === -1) {
                        return null;
                      }
                    }
                  }
                  return (
                    <div className={`user-item ${item.id === _.get(currentData, 'id', '') ? 'user-item-active' : ''}`} key={item.id} onClick={() => {
                      setCurrentData(item);
                    }}>
                      <img className="user-icon" src={item.avatarUrl} alt="" />
                      <div className="user-content">
                        <div className="user-content-top">
                          <div className="user-name">
                          <OpenData type="userName" openid={_.get(item  , 'firstWxUserId', _.get(item  , 'openWxUserid', ''))}>
                            {_.get(item , 'name', '')}
                          </OpenData>
                          </div>
                          {
                            (item.userTab === '1' || item.userTab === '0') ? null :
                            !item.status ? ( <div className="user-label user-leave">离职</div> ) : (
                                <div className="user-label">在职</div>
                              )
                          }
                          {
                            (item.beInherited ? <div className="user-label user-inheritance">被继承</div> : null )
                          } 
                        </div>
                        <div className="user-dep">{item.departmentName}
                        {/* 产品研发中心/产品部 */}
                        </div>
                      </div>
                      <div className="user-message">{
                        item.thirdChatMsgCount ?
                        Number(item.thirdChatMsgCount) > 99 ? 
                          '99+' :
                          item.thirdChatMsgCount :
                        '暂无'
                      }</div>
                    </div>
                  );
                })
              }
            </div>
          </> 
        ) : (
          <>
            <div className="search-box-hidden" onClick={() => setShowAll(!showAll)}>
              <SearchOutlined
                style={{
                  color: '#9A9EBA',
                  fontSize: 16,
                }}
              />
            </div>
            <div className="tab-box-hidden">
              <img src={RefreshImg} className="tab-item-refresh" onClick={() => {refresh()}}/>
              <div className="action-box" onClick={() => setShowAll(!showAll)}>
                <img src={DoubleleftSvg} />
              </div>
            </div>

            <div className="user-box-hidden scroll-style">
              {
                list.map(item => {
                  return (
                    <div className={`user-item ${item.id === _.get(currentData, 'id', '') ? 'user-item-active' : ''}`} key={item.id} onClick={() => {
                      setCurrentData(item);
                    }}>
                      <img className="user-icon" src={item.avatarUrl} alt="" />
                      <div className="user-message">{
                        item.thirdChatMsgCount ?
                        Number(item.thirdChatMsgCount) > 99 ? 
                          '99+' :
                          item.thirdChatMsgCount :
                        '暂无'
                      }</div>
                    </div>
                  );
                })
              }
            </div>
          </>
        )
      }
      </Spin>
    </Wrapper>
  );
};

export default CovSearchUserList;